var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElementTiptap',{attrs:{"width":"100%","extensions":_vm.extensions,"lang":"pt_br"},model:{value:(_vm.item.conteudo),callback:function ($$v) {_vm.$set(_vm.item, "conteudo", $$v)},expression:"item.conteudo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }